import { IMessageType } from '@/services/signalr/types';
import { IAlertUpdateReqMsg } from '~/api/messages/IAlertUpdateReqMsg';
import { IAlertUpdateRespMsg } from '~/api/messages/IAlertUpdateRespMsg';
import { IAlertsReqMsg } from '~/api/messages/IAlertsReqMsg';
import { IAlertsRespMsg } from '~/api/messages/IAlertsRespMsg';

export const AlertsReqMsg: IMessageType<IAlertsReqMsg, IAlertsRespMsg> = {
  requestName: 'AlertsReqMsg',
  responseName: 'AlertsRespMsg',
};

export const AlertUpdateReqMsg: IMessageType<IAlertUpdateReqMsg, IAlertUpdateRespMsg> = {
  requestName: 'AlertUpdateReqMsg',
  responseName: 'AlertUpdateRespMsg',
};
